"use client";

import React from "react";

type NavItemProps = {
  children: React.ReactNode;
  className?: string;
  align?: "left" | "center" | "right";
};

export function NavItem({
  children,
  className,
  align = "center",
}: NavItemProps) {
  const alignClass =
    align === "left"
      ? "justify-start"
      : align === "right"
        ? "justify-end"
        : "justify-center";

  return (
    <div className={`flex items-center ${alignClass} ${className || ""}`}>
      {children}
    </div>
  );
}
